<dsw-footer [locale]="languageLocale"
  ><div version class="flex items-center gap-[8px]">
    <ng-container *ngIf="authStore.isCompanyFromGermany$ | async">
      <a
        class="icon"
        href="https://www.linkedin.com/company/viessmannclimatesolutions/"
        target="_blank"
        rel="noopener noreferrer"
        ><img icon src="assets/icons/linkedin.svg"
      /></a>
      <a
        class="icon"
        href="https://www.instagram.com/viessmannclimatesolutionsde"
        target="_blank"
        rel="noopener noreferrer"
        ><img icon src="assets/icons/instagram.svg"
      /></a>
      <a
        class="icon"
        href="https://www.facebook.com/ViessmannClimateSolutionsGER"
        target="_blank"
        rel="noopener noreferrer"
        ><img icon src="assets/icons/facebook.svg"
      /></a>
      <a
        class="icon"
        href="https://www.youtube.com/@ViessmannClimateSolutionsDE"
        target="_blank"
        rel="noopener noreferrer"
        ><img icon src="assets/icons/youtube.svg"
      /></a>
      <a
        class="icon"
        href="https://www.tiktok.com/@viessmanncs_de"
        target="_blank"
        rel="noopener noreferrer"
        ><img icon src="assets/icons/tiktok.svg"
      /></a>
    </ng-container>
    <span>v{{ appVersion }}</span>
  </div>
</dsw-footer>
